import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { Switch } from '../../../../../../components/Switch/Switch';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}

// report 035
export function TournamentSchoolStartListReportForm(props: Props) {
  const requestInitial = {
    isShowBlank: true,
    isHighlightNoAge: true
  };

  return (
    <Formik
      onSubmit={values => {
        props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_SCHOOL_START_LIST);
      }}
      initialValues={requestInitial}>
      
      {({ values, setFieldValue }) => (
        <Form className="tournamentReportFormModern">
          <div className="bReportFormTitle">Tournament school start list</div>
          <div className="mb-3 mt-3">
            {'View details of your schools entries into your chosen tournament, ' +
              'which students you have added to your team and who is participating in which event.'}
          </div>

          <div className="tournamentReportFormModern__options">
            <div className="tournamentReportFormModern__option">
              <div>
                <strong>Show empty events</strong>
                <small>Show events you have not yet added participants to.</small>
              </div>
              <Switch
                name="isShowBlank"
                value={values.isShowBlank}
                onChange={event => setFieldValue('isShowBlank', event.target.checked)}
              />
            </div>
            <div className="tournamentReportFormModern__option">
              <div>
                <strong>Highlight students without DOB</strong>
                <small>Highlight students if their data does not contain their date of birth.</small>
              </div>
              <Switch
                name="isHighlightNoAge"
                value={values.isHighlightNoAge}
                onChange={event => setFieldValue('isHighlightNoAge', event.target.checked)}
              />
            </div>
          </div>

          <div className="tournamentReportFormModern__footer">
            <button type="button" className="btn btn-secondary" onClick={props.onCloseClick}>Cancel</button>
            <button type="submit" className="btn btn-primary">Generate report</button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

